// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as ReactModal from "react-modal";
import * as SelectLocationCmp$PorterinFeature from "./SelectLocationCmp.mjs";
import * as LocationAccuracyCmp$PorterinFeature from "./LocationAccuracyCmp.mjs";
import * as LocationAccuracyModalCmpModuleScss from "../styles/LocationAccuracyModalCmp.module.scss";
import * as LocationAccuracyModalStateMachine$PorterinFeature from "../view-model/state-machine/LocationAccuracyModalStateMachine.mjs";

var styles = LocationAccuracyModalCmpModuleScss;

function LocationAccuracyModalCmp(Props) {
  var modal_state = Props.modal_state;
  var waypoint = Props.waypoint;
  var close_modal = Props.close_modal;
  var on_location_select = Props.on_location_select;
  var match = React.useReducer(LocationAccuracyModalStateMachine$PorterinFeature.reducer, LocationAccuracyModalStateMachine$PorterinFeature.getInitialState(undefined));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.steps;
  var tmp;
  if (match$1) {
    var match$2 = state.address;
    var match$3 = state.geoAddress;
    tmp = match$2 !== undefined && match$3 !== undefined ? React.createElement(LocationAccuracyCmp$PorterinFeature.make, {
            waypoint: waypoint,
            center_position: state.mapCenter,
            open_select_location: (function (param) {
                Curry._1(dispatch, {
                      TAG: /* SetStep */0,
                      _0: /* SelectLocation */0
                    });
              }),
            on_location_select: (function (address, geo_address) {
                Curry._2(on_location_select, address, geo_address);
                Curry._1(dispatch, {
                      TAG: /* SetStep */0,
                      _0: /* SelectLocation */0
                    });
                Curry._1(close_modal, undefined);
              }),
            location_address: {
              address: match$2,
              postalAddress: match$3
            }
          }) : null;
  } else {
    tmp = React.createElement(SelectLocationCmp$PorterinFeature.make, {
          waypoint: waypoint,
          close_modal: close_modal,
          on_location_select: (function (address, geo_address) {
              Curry._1(dispatch, {
                    TAG: /* SetAddress */2,
                    _0: address
                  });
              Curry._1(dispatch, {
                    TAG: /* SetGeoPostalAddress */3,
                    _0: geo_address
                  });
              Curry._1(dispatch, {
                    TAG: /* SetMapCenter */1,
                    _0: {
                      lat: address.location.lat,
                      lng: address.location.lng
                    }
                  });
              Curry._1(dispatch, {
                    TAG: /* SetStep */0,
                    _0: /* LocationAccuracy */1
                  });
            })
        });
  }
  return React.createElement(ReactModal, {
              isOpen: modal_state,
              onRequestClose: close_modal,
              closeTimeoutMS: 0,
              overlayClassName: styles.overlay,
              className: "" + styles["modal-container"] + "",
              ariaHideApp: false,
              shouldCloseOnOverlayClick: true,
              children: tmp
            });
}

var make = LocationAccuracyModalCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
